import React from "react";
import { motion } from "framer-motion";
import { EasyonReveal } from "./EasyonMotion";

const inventoryRows = [
    { product: "Product A", category: "Electronics", units: "1,250 Units", status: "In Stock" },
    { product: "Product B", category: "Accessories", units: "850 Units", status: "In Stock" },
    { product: "Product C", category: "Components", units: "420 Units", status: "Low Stock" },
    { product: "Product D", category: "Hardware", units: "1,800 Units", status: "In Stock" },
    { product: "Product E", category: "Consumables", units: "120 Units", status: "Reorder" },
];

export const EasyonInventorySection = () => (
    <section className="eo-inventory">
        <div className="eo-container eo-inventory__layout">
            <EasyonReveal className="eo-inventory__copy">
                <span className="eo-eyebrow">Inventory Visualization</span>
                <h2 className="eo-h2">See Stock Health in One Glance</h2>
                <p className="eo-lead">
                    Monitor stock levels by product category through a clean, operational view designed for fast ERP decisions.
                </p>
            </EasyonReveal>

            <motion.div
                className="eo-inventory-chart"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ duration: 0.6 }}
            >
                <div className="eo-inventory-table">
                    <div className="eo-inventory-table__head">
                        <span>Product</span>
                        <span>Category</span>
                        <span>Quantity</span>
                        <span>Status</span>
                    </div>
                    <div className="eo-inventory-table__body">
                        {inventoryRows.map((item) => (
                            <div key={item.product} className="eo-inventory-table__row">
                                <span>{item.product}</span>
                                <span>{item.category}</span>
                                <strong>{item.units}</strong>
                                <span className={`eo-inventory-badge eo-inventory-badge--${item.status.toLowerCase().replace(" ", "-")}`}>
                                    {item.status}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);
